import axios from "../axios-auth";

export const shopTypeService = {
    getShopTypeList,
    getShopTypeDetail,
    saveShopType
}

function getShopTypeList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/shop_type", { params });
}

function getShopTypeDetail(id) {
    return axios.get("/auth/shop_type/" + id);
}

function saveShopType(shopType) {
    if (!shopType.id) {
        // new shop type
        return axios.post("/auth/shop_type", shopType);
    } else {
        // edit
        return axios.put("/auth/shop_type", shopType);
    }
}
